<template>
	<el-dialog :visible="show" append-to-body width="740px" title="添加场景" :close-on-click-modal="false" @close="closeDialog">
		<el-form label-width="60px">
      <el-form-item v-if="row.type === 3" label="分组">
        <div class="group-list"  >
          <div class="group-item" v-for="item in row.groupList" :key="item.id" :class="{active:item.id === groupId}" @click="groupId = item.id">{{item.remarkTime}}</div>
        </div>
      </el-form-item>
			<el-form-item label="场景" prop="materialData" required>
				<vr-upload v-model="materialData" :loading.sync="doSubmitLoading" />
				<div class="v-form-tips">请上传2:1的全景图片，例如：宽6000px，高3000px，拖拽可以进行排序</div>
			</el-form-item>
		</el-form>
		<div slot="footer" class="dialog-footer">
			<el-button size="small" @click="closeDialog">关闭</el-button>
			<el-button type="primary" size="small" :loading="doSubmitLoading" @click="doSubmit">确 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	import vrUpload from '@/pages-saas/works/components/vr-upload'

	export default {

		components: {vrUpload},

		props: {
			show: Boolean,
			worksId:{
				type:Number,
				default:0
			},
			row: {
				type: Object,
				default: null
			}
		},

		data() {
			return {
				doSubmitLoading: false,
				materialData: [],
        groupId:this.row.groupList[0].id
			}
		},

		methods: {

			closeDialog() {
				this.$emit('update:show', false)
			},

			async doSubmit() {
				if (this.materialData.length == 0) {
					this.$message.error('请先上传全景图片')
					return
				}
				this.doSubmitLoading = true;
				try {
					await this.api.material.addSingleMaterial({worksId: this.worksId, materialData: this.materialData,groupId:this.groupId});
					this.$message.success(`添加成功`);
					this.$emit('success')
					this.closeDialog();
				} catch (e) {
					console.error(e);
				}
				this.doSubmitLoading = false;
			},


		}
	}
</script>

<style scoped>
  .group-list{
    display:flex;
    margin-top:5px;
  }
  .group-item{
    margin: 0 10px 10px 0;
    border:1px solid #ccc;
    height:30px;
    padding:0 15px;
    border-radius: 4px;
    cursor: pointer;
    display:flex;
    align-items: center;
    justify-content: center;
  }
  .group-item.active{
    border-color:#66b1ff;
    color:#66b1ff;
  }
</style>

